import React from "react";
import { FormGroup, RadioGroup, FieldErrorMessage, Label } from "./styles";

const InputRadioCustom = ({ className, description, name, value, options, handleChange, handleBlur, isInvalid, errors, rowDirection = true }) => {
    return (
        <FormGroup className={className}>
            {isInvalid && (
                <FieldErrorMessage>{errors}</FieldErrorMessage>
            )}
            <RadioGroup rowDirection={rowDirection}>
                {options?.map((item, index) => (
                    <div className="radio" key={index}>
                        <input
                            id={`radio-${index}`}
                            value={item.value}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name={name}
                            type="radio"
                            checked={value !== undefined ? (value === item.value ? true : false) : undefined}
                        />
                        <label htmlFor={`radio-${index}`} className="radio-label">
                            {item.label}
                        </label>
                    </div>
                ))}
            </RadioGroup>
            {description && (
                <Label>{description}</Label>
            )}
        </FormGroup>
    );
};

export default InputRadioCustom;